import { hasSession } from "@/modules/auth/lib/authenticationClient";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/__authed")({
	beforeLoad({ location, context }) {
		const token = "token" in context && typeof context.token === "string" ? context.token : null;

		if (!token && !hasSession()) {
			throw redirect({
				to: "/auth/login",
				search: { redirectTo: location.pathname },
			});
		}
	},
});
